import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="container-custom py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 group">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 text-white rounded-lg group-hover:bg-primary-400 transition-colors">
                <i className="ri-play-circle-fill text-xl"></i>
              </div>
              <span className="font-serif font-bold text-lg text-white whitespace-nowrap">日本在线观看</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              高清日本影视资源免费在线观看平台，涵盖日剧、动漫、综艺、电影，每日更新，随时随地畅享日本影视内容。
            </p>
          </div>

          <div>
            <h4 className="font-serif font-semibold text-white mb-4">
              <a href="#browse-categories" className="hover:text-primary-400 transition-colors">分类浏览</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors flex items-center gap-2"
                  >
                    <i className={`${cat.icon} text-xs`}></i>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-serif font-semibold text-white mb-4">快捷链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors">首页</Link></li>
              <li><Link to="/articles" className="text-sm text-background-400 hover:text-primary-400 transition-colors">影视资讯</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">关于我们</Link></li>
              <li><a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors">常见问题</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-serif font-semibold text-white mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-primary-400"></i>
                support@japanvod.example.com
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line text-primary-400"></i>
                日本东京都港区
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-time-line text-primary-400"></i>
                周一至周日 9:00 - 22:00
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2020-2024 日本在线观看. 本站内容仅供学习交流使用，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-primary-400 transition-colors text-xs" rel="nofollow">免责声明</a>
            <a href="#" className="text-background-500 hover:text-primary-400 transition-colors text-xs" rel="nofollow">隐私政策</a>
            <a href="#" className="text-background-500 hover:text-primary-400 transition-colors text-xs" rel="nofollow">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}